(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-card"] && !Shopify.designMode) return;
  try {
    /* Equalize blog card title heights per row */
  function equalizeTitleHeights() {
    const titles = document.querySelectorAll('.blog-post-item .blog-post-card__content > a[data-testid="blog-post-link"]');
    if (!titles.length) return;

    /* Reset heights first */
    titles.forEach(t => t.style.minHeight = '');

    /* Group by row (same offsetTop on parent card) */
    const rows = {};
    titles.forEach(t => {
      const card = t.closest('.blog-post-item');
      if (!card) return;
      const top = Math.round(card.getBoundingClientRect().top);
      if (!rows[top]) rows[top] = [];
      rows[top].push(t);
    });

    /* Set min-height per row to the tallest title */
    Object.values(rows).forEach(row => {
      const max = Math.max(...row.map(t => t.scrollHeight));
      row.forEach(t => t.style.minHeight = max + 'px');
    });
  }

  equalizeTitleHeights();
  window.addEventListener('resize', equalizeTitleHeights);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["vb-product-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    function set(root, d, h, m, s) {
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var pairs = [
        ['[data-vb-days]', pad(d)],
        ['[data-vb-hours]', pad(h)],
        ['[data-vb-minutes]', pad(m)],
        ['[data-vb-seconds]', pad(s)]
      ];
      for (var i = 0; i < pairs.length; i++) {
        var nodes = root.querySelectorAll(pairs[i][0]);
        for (var j = 0; j < nodes.length; j++) nodes[j].textContent = pairs[i][1];
      }
    }

    function tick(root) {
      var endTs = Date.parse(root.dataset.end);
      if (isNaN(endTs)) return true;
      var diff = endTs - Date.now();
      if (diff <= 0) {
        if (root.dataset.hideOnExpire === 'true') {
          root.style.display = 'none';
          return true;
        }
        root.classList.add('is-expired');
        var bar = root.querySelector('[data-vb-text]');
        var boxes = root.querySelector('.vb-countdown__boxes');
        if (root.dataset.expiredText) {
          if (bar) bar.textContent = root.dataset.expiredText;
          if (boxes) boxes.outerHTML = '<div class="vb-countdown__bar">' + root.dataset.expiredText + '</div>';
        } else {
          set(root, 0, 0, 0, 0);
        }
        return true;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      s -= d * 86400;
      var h = Math.floor(s / 3600);
      s -= h * 3600;
      var m = Math.floor(s / 60);
      s -= m * 60;
      set(root, d, h, m, s);
      return false;
    }

    function init() {
      var roots = document.querySelectorAll('[data-vb-countdown]');
      roots.forEach(function (root) {
        if (root.dataset.vbInit) return;
        root.dataset.vbInit = '1';
        if (tick(root)) return;
        var id = setInterval(function () {
          if (tick(root)) clearInterval(id);
        }, 1000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
